/* ==========================================================================
   Collection Hub — Size/Color filter interactions + video tile autoplay
   ========================================================================== */
(function () {
  function initFilters() {
    var containers = document.querySelectorAll('[data-collection-hub-filters]');
    if (!containers.length) return;

    containers.forEach(function (container) {
      var grid = document.querySelector('.collection-matrix');
      if (!grid) return;

      var toggles = container.querySelectorAll('[data-filter-toggle]');
      var clearBtn = container.querySelector('[data-filter-clear]');
      var resultCount = container.querySelector('[data-filter-result-count]');

      function closeAllPanels() {
        toggles.forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          var p = b.parentElement.querySelector('[data-filter-panel]');
          if (p) p.hidden = true;
        });
      }

      toggles.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var panel = btn.parentElement.querySelector('[data-filter-panel]');
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          closeAllPanels();
          if (!isOpen && panel) {
            btn.setAttribute('aria-expanded', 'true');
            panel.hidden = false;
          }
        });
      });

      container.querySelectorAll('[data-filter-done]').forEach(function (doneBtn) {
        doneBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          closeAllPanels();
        });
      });

      container.querySelectorAll('[data-filter-panel]').forEach(function (panel) {
        panel.addEventListener('click', function (e) {
          e.stopPropagation();
        });
      });

      document.addEventListener('click', function (e) {
        if (!container.contains(e.target)) closeAllPanels();
      });

      function getActive(type) {
        var inputs = container.querySelectorAll('[data-filter-input="' + type + '"]:checked');
        return Array.prototype.map.call(inputs, function (el) {
          return el.value;
        });
      }

      function applyFilters() {
        var items = grid.querySelectorAll('.product__grid-item');
        var activeSizes = getActive('size');
        var activeColors = getActive('color');
        var anyActive = activeSizes.length > 0 || activeColors.length > 0;
        var visible = 0;

        items.forEach(function (item) {
          var itemSizes = (item.getAttribute('data-hub-sizes') || '').split('|').filter(Boolean);
          var itemColors = (item.getAttribute('data-hub-colors') || '').split('|').filter(Boolean);
          var sizeMatch = activeSizes.length === 0 || activeSizes.some(function (s) {
            return itemSizes.indexOf(s) !== -1;
          });
          var colorMatch = activeColors.length === 0 || activeColors.some(function (c) {
            return itemColors.indexOf(c) !== -1;
          });
          var show = sizeMatch && colorMatch;
          item.classList.toggle('is-hub-filtered-out', !show);
          if (show) visible++;
        });

        container.querySelectorAll('[data-filter-group]').forEach(function (group) {
          var type = group.getAttribute('data-filter-group');
          var count = getActive(type).length;
          var badge = group.querySelector('[data-filter-count]');
          if (badge) badge.textContent = count ? '(' + count + ')' : '';
        });

        if (clearBtn) clearBtn.hidden = !anyActive;
        if (resultCount) {
          resultCount.textContent = anyActive ? visible + ' item' + (visible === 1 ? '' : 's') : '';
        }

        var wrapper = grid.closest('.collection-matrix__wrapper') || grid.parentElement || grid;
        var emptyMsg = wrapper.querySelector('[data-hub-empty-message]');
        if (anyActive && visible === 0) {
          if (!emptyMsg) {
            emptyMsg = document.createElement('div');
            emptyMsg.setAttribute('data-hub-empty-message', '');
            emptyMsg.className = 'collection-hub-filters__empty';
            emptyMsg.textContent = 'No products match your filters. Try clearing a filter.';
            wrapper.appendChild(emptyMsg);
          }
          emptyMsg.hidden = false;
        } else if (emptyMsg) {
          emptyMsg.hidden = true;
        }

        // With the auto-loading pagination types (infinite_scroll /
        // infinite_load_more) filtering products out with display:none
        // shrinks the grid's height, which can leave the load trigger
        // sitting inside the viewport without the theme's Waypoints library
        // noticing (it only recalculates on scroll/resize) — nudging both
        // events after every filter pass fixes that. Under the current
        // "load_more" button pagination type this is a harmless no-op
        // (nothing auto-loads), which is intentional: batches only load
        // when the shopper clicks "Load More" themselves.
        window.dispatchEvent(new Event('resize'));
        window.dispatchEvent(new Event('scroll'));
      }

      container.querySelectorAll('[data-filter-input]').forEach(function (input) {
        input.addEventListener('change', applyFilters);
      });

      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          container.querySelectorAll('[data-filter-input]:checked').forEach(function (input) {
            input.checked = false;
          });
          applyFilters();
        });
      }

      // The theme's native infinite scroll (Waypoints) appends new
      // .product__grid-item nodes into the grid as the shopper scrolls.
      // Without this observer, Size/Color filters only ever evaluated
      // whatever page was in the DOM when the shopper opened the filter —
      // re-running applyFilters() whenever new items land keeps the active
      // filter selections applied across the entire collection, not just
      // the first batch.
      var gridObserver = new MutationObserver(function (mutations) {
        var added = mutations.some(function (m) {
          return m.addedNodes && m.addedNodes.length > 0;
        });
        if (added) applyFilters();
      });
      gridObserver.observe(grid, { childList: true });
    });
  }

  function initSubcategoryBar() {
    var bars = document.querySelectorAll('[data-subcat-bar]');
    if (!bars.length) return;

    bars.forEach(function (wrap) {
      var scroller = wrap.querySelector('[data-subcat-scroll]');
      var prevBtn = wrap.querySelector('[data-subcat-prev]');
      var nextBtn = wrap.querySelector('[data-subcat-next]');
      if (!scroller) return;

      function updateEdges() {
        var maxScroll = scroller.scrollWidth - scroller.clientWidth;
        var hasOverflow = maxScroll > 4;
        var atStart = scroller.scrollLeft <= 4;
        var atEnd = scroller.scrollLeft >= maxScroll - 4;

        wrap.classList.toggle('is-scrolled-left', hasOverflow && !atStart);
        wrap.classList.toggle('is-scrollable-right', hasOverflow && !atEnd);

        if (prevBtn) prevBtn.hidden = !hasOverflow || atStart;
        if (nextBtn) nextBtn.hidden = !hasOverflow || atEnd;
      }

      var scrollAmount = function () {
        return Math.max(scroller.clientWidth * 0.7, 160);
      };

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          scroller.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          scroller.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
        });
      }

      scroller.addEventListener('scroll', updateEdges);
      window.addEventListener('resize', updateEdges);
      updateEdges();

      // Click-and-drag scrolling for desktop mouse users (touch/trackpad
      // already scroll natively via overflow-x). On collections where the
      // bar wraps onto multiple rows instead of scrolling (see the
      // `--wrap-rows` modifier in collection-hub.css), scroller.scrollWidth
      // ends up equal to clientWidth, updateEdges() above finds no
      // overflow, and this drag handling simply never has anything to do —
      // no extra guard needed here.
      var isDown = false;
      var startX = 0;
      var startScrollLeft = 0;
      var dragged = false;

      scroller.addEventListener('mousedown', function (e) {
        isDown = true;
        dragged = false;
        startX = e.pageX;
        startScrollLeft = scroller.scrollLeft;
        scroller.classList.add('is-dragging');
      });

      window.addEventListener('mouseup', function () {
        if (!isDown) return;
        isDown = false;
        scroller.classList.remove('is-dragging');
      });

      window.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        var delta = e.pageX - startX;
        if (Math.abs(delta) > 3) dragged = true;
        scroller.scrollLeft = startScrollLeft - delta;
      });

      // Suppress the click-through to a link if the user was actually
      // dragging rather than clicking
      scroller.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function (e) {
          if (dragged) {
            e.preventDefault();
            dragged = false;
          }
        });
      });
    });
  }

  function initPrefetchNextPage() {
    // Quietly warms the browser's own HTTP cache for the next "Load More"
    // page while the shopper is just browsing, so both a manual "Load
    // More" click and the catch-up restoration below (initScrollRestoration)
    // have a good chance of resolving straight from cache instead of
    // waiting on a fresh round trip.
    var grid = document.querySelector('.collection-matrix');
    if (!grid) return;

    var loadMoreSelector = '[data-load-more], [data-load-infinite], [data-load-more-infinite]';
    var prefetchedHref = null;

    function prefetchNext() {
      var loadMoreEl = document.querySelector(loadMoreSelector);
      var href = loadMoreEl ? loadMoreEl.getAttribute('href') : null;
      if (!href || href === prefetchedHref) return;
      prefetchedHref = href;

      var run = function () {
        fetch(href, { credentials: 'same-origin' }).catch(function () {});
      };
      if ('requestIdleCallback' in window) {
        requestIdleCallback(run, { timeout: 2000 });
      } else {
        setTimeout(run, 800);
      }
    }

    prefetchNext();
    new MutationObserver(prefetchNext).observe(grid, { childList: true });
  }

  function initScrollRestoration() {
    // What was landing shoppers in the footer: when this page isn't
    // eligible for the browser's back/forward cache (bfcache) — common on
    // theme pages carrying analytics beacons, chat widgets, etc. — hitting
    // Back does a full fresh reload. That reload only renders page 1 (the
    // first pagination_limit items), which is much SHORTER than the page
    // was when the shopper had clicked "Load More" a few times. The
    // browser's own automatic scroll restoration still tries to jump to
    // the old (tall-page) Y offset, and since that offset no longer
    // exists on the short page, it clamps to the max scroll — the very
    // bottom, i.e. the footer.
    //
    // The fix: take manual control of scroll restoration, remember how
    // many products were loaded + how far the shopper had scrolled, and
    // on the way back, catch the grid up to that same item count (via the
    // theme's own real "Load More" click handling — cheap here since
    // initPrefetchNextPage above already warms the first hop) before
    // scrolling to the saved position. This grows the page a little
    // before settling, which reads as it catching up rather than as a
    // second reload, and it always lands in the right place instead of
    // wherever the shorter page happened to clamp to.
    var grid = document.querySelector('.collection-matrix');
    if (!grid) return;

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    var storageKey = 'hubScroll:' + location.pathname + location.search;

    function itemCount() {
      return grid.querySelectorAll('.product__grid-item').length;
    }

    function saveState() {
      try {
        sessionStorage.setItem(storageKey, JSON.stringify({ count: itemCount(), y: window.scrollY }));
      } catch (e) {}
    }

    // Round 12 fix: read whatever the PREVIOUS view of this page saved
    // (via the pagehide listener below) BEFORE anything on this fresh
    // load gets a chance to overwrite it. Earlier rounds called
    // saveState() once immediately here to "establish a baseline" — but
    // that ran before this read, so on every fresh reload it clobbered
    // the real saved snapshot with the just-loaded page's OWN state
    // (count = however many items page 1 has, y = 0, since we're at the
    // top of a brand-new load). The restore logic below was then always
    // comparing the fresh page against itself — itemCount() >= saved.count
    // was trivially true and saved.y was always 0 — so it silently did
    // nothing every single time, regardless of what actually shipped in
    // rounds 9-11. Reading first — before any save happens on this
    // view — is what makes the saved snapshot from the *prior* view
    // actually reach the restore logic below.
    var raw;
    try {
      raw = sessionStorage.getItem(storageKey);
    } catch (e) {
      raw = null;
    }

    var saveTimer;
    function scheduleSave() {
      clearTimeout(saveTimer);
      saveTimer = setTimeout(saveState, 200);
    }
    window.addEventListener('scroll', scheduleSave, { passive: true });
    new MutationObserver(scheduleSave).observe(grid, { childList: true });

    // pagehide fires reliably at the moment the page is actually being
    // left (including right before a bfcache freeze) — this is the save
    // that matters, with no debounce, so a scroll or Load More click
    // right before the shopper clicks into a product is never lost to a
    // pending 200ms timer. visibilitychange (hidden) is added as a
    // second, earlier-firing safety net: pagehide has known ordering
    // quirks on mobile Safari, and visibilitychange is the
    // cross-browser-recommended fallback for "the shopper is leaving."
    window.addEventListener('pagehide', saveState);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') saveState();
    });

    // Only attempt the catch-up/restore on an actual back/forward
    // navigation — a plain link click into this same URL should just
    // load fresh at the top like normal. If the Navigation Timing API
    // isn't available to tell us, err on the side of attempting the
    // restore rather than silently leaving the shopper at the top.
    var navEntries = performance.getEntriesByType && performance.getEntriesByType('navigation');
    var navType = navEntries && navEntries[0] && navEntries[0].type;
    if (navType && navType !== 'back_forward') return;

    if (!raw) return;

    var saved;
    try {
      saved = JSON.parse(raw);
    } catch (e) {
      return;
    }
    if (!saved || !saved.count || itemCount() >= saved.count) {
      if (saved && saved.y) {
        requestAnimationFrame(function () {
          window.scrollTo(0, saved.y);
        });
      }
      return;
    }

    var attempts = 0;
    var maxAttempts = 30;

    function finish() {
      requestAnimationFrame(function () {
        window.scrollTo(0, saved.y);
      });
    }

    function growAndRestore() {
      attempts++;
      var loadMoreBtn = document.querySelector(
        '[data-load-more], [data-load-infinite], [data-load-more-infinite]'
      );
      if (itemCount() >= saved.count || !loadMoreBtn || attempts > maxAttempts) {
        finish();
        return;
      }

      var countBefore = itemCount();
      loadMoreBtn.click();

      var settleTimer;
      var observer = new MutationObserver(function () {
        clearTimeout(settleTimer);
        settleTimer = setTimeout(function () {
          observer.disconnect();
          growAndRestore();
        }, 150);
      });
      observer.observe(grid, { childList: true });

      // Safety net in case that click didn't append anything (e.g. the
      // theme's handler wasn't ready yet, or this really was the last page)
      settleTimer = setTimeout(function () {
        observer.disconnect();
        if (itemCount() === countBefore) {
          finish();
        } else {
          growAndRestore();
        }
      }, 1500);
    }

    growAndRestore();
  }

  function initNativeLoadMore() {
    // The theme's own "Load More" / infinite-scroll click handling
    // (window.PXUTheme.infiniteScroll.init(), defined in utilities.js) is
    // normally wired up by app.js's 'shopify:section:load' listener — but
    // that event only fires inside the Shopify theme editor, never on a
    // plain storefront page view. Without it, the [data-load-more] link
    // never gets its click intercepted, so clicking "Load More" just
    // follows the link's href like a normal browser navigation — a full
    // page reload back to page 1, losing scroll position/filters. Calling
    // init() here (it uses delegated jQuery events + does its own .off()
    // before .on(), so it's safe to call more than once) makes the button
    // actually work on a real page load, matching how it already behaves
    // in the theme editor.
    if (
      window.PXUTheme &&
      window.PXUTheme.infiniteScroll &&
      typeof window.PXUTheme.infiniteScroll.init === 'function'
    ) {
      window.PXUTheme.infiniteScroll.init();
    }
  }

  function initVideoTiles() {
    var tiles = document.querySelectorAll('[data-hub-video]');
    if (!tiles.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target.querySelector('video');
          if (!video) return;
          if (entry.isIntersecting) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.4 }
    );

    tiles.forEach(function (tile) {
      observer.observe(tile);
    });
  }

  function init() {
    initFilters();
    initSubcategoryBar();
    initNativeLoadMore();
    initPrefetchNextPage();
    initScrollRestoration();
    initVideoTiles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
